export default __webpack_public_path__ + "c60ddf8b74c96f59ae869080ddc3dbb2.svg";